module.exports = __webpack_public_path__ + "static/media/icofont.4f7f7bf7.svg";